import type { FunctionComponent } from 'react';

import * as styles from './BoardHeaderButtonDivider.module.less';

export const BoardHeaderButtonDivider: FunctionComponent = () => {
  return <span className={styles.boardHeaderButtonDivider} />;
};
